import axios from 'axios';
import { GOOGLE_API_KEY } from '../config';

export default async zip =>
  await axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?key=${GOOGLE_API_KEY}&language=en&components=postal_code:${zip}`
  );
